import React from 'react';
import { CopyOutlined, CheckOutlined } from '@ant-design/icons';

import * as S from './ProductDetailRow.styled';

export type ProductDetail = {
  icon: React.ReactNode;
  label: string;
  value: string | number | React.ReactNode;
  enableCopy?: boolean;
};

interface ProductDetailsRowProps {
  details: ProductDetail[];
}

export default function ProductDetailsRow({ details }: ProductDetailsRowProps) {
  return (
    <S.DetailsRowContainer>
      {details.map(({ icon, label, value, enableCopy }) => (
        <S.DetailItem key={`${label}-${value}`}>
          <div className="detail-header">
            {icon}
            <span>{label}</span>
          </div>
          <S.StyledText
            className={`detail-value ${value === 'N/A' ? 'value-na' : ''}`}
            copyable={
              enableCopy
                ? {
                    text: typeof value === 'string' ? value : String(value),
                    tooltips: ['Copiar', 'Copiado!'],
                    icon: [<CopyOutlined />, <CheckOutlined />],
                  }
                : false
            }
          >
            {value}
          </S.StyledText>
        </S.DetailItem>
      ))}
    </S.DetailsRowContainer>
  );
}
